import { orderHistorySearchTagsStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags";
import { horizontalStyles } from "@ucs/Components/TagOutline";
import { css } from "styled-components";



orderHistorySearchTagsStyles.appliedFiltersContainer = {
    css: css`
        padding: 0px 10px;
        display: flex;
        flex-wrap: wrap;
    `,
};

orderHistorySearchTagsStyles.appliedFilterTag = {
    typographyProps: {
        css: css`
            text-transform: uppercase;
            padding: 8px 5px 8px 0px;
        `, 
    },
};
